import DomTravelerDeclarationFirstEn from "./dom_traveler_declaration/dom_traveler_declaration_upload_01_en.png";
import DomTravelerDeclarationSecondEn from "./dom_traveler_declaration/dom_traveler_declaration_upload_02_en.png";

import DomTravelerDeclarationFirstEs from "./dom_traveler_declaration/dom_traveler_declaration_upload_01_es.png";
import DomTravelerDeclarationSecondEs from "./dom_traveler_declaration/dom_traveler_declaration_upload_02_es.png";

import DomTravelerDeclarationFirstPt from "./dom_traveler_declaration/dom_traveler_declaration_upload_01_pt.png";
import DomTravelerDeclarationSecondPt from "./dom_traveler_declaration/dom_traveler_declaration_upload_02_pt.png";

import HndTravelerDeclarationFirstEn from "./hnd_traveler_declaration/hnd_traveler_declaration_upload_01_en.png";
import HndTravelerDeclarationFirstEs from "./hnd_traveler_declaration/hnd_traveler_declaration_upload_01_es.png";

import ThaTravelerDeclaration from "./tha_traveler_declaration/tha_traveler_declaration_upload_01_en.png";

const UploadInstructions = {
  domTravelerDeclaration: {
    en: {
      first: DomTravelerDeclarationFirstEn,
      second: DomTravelerDeclarationSecondEn,
    },
    es: {
      first: DomTravelerDeclarationFirstEs,
      second: DomTravelerDeclarationSecondEs,
    },
    pt: {
      first: DomTravelerDeclarationFirstPt,
      second: DomTravelerDeclarationSecondPt,
    }
  },
  hndTravelerDeclaration: {
    en: {
      first: HndTravelerDeclarationFirstEn
    },
    es: {
      first: HndTravelerDeclarationFirstEs
    },
    pt: {
      first: HndTravelerDeclarationFirstEn
    }
  },
  thaTravelerDeclaration: {
    en: {
      first: ThaTravelerDeclaration
    },
    es: {
      first: ThaTravelerDeclaration
    },
    pt: {
      first: ThaTravelerDeclaration
    }
  },
} as const;

export type LanguageCode = keyof typeof UploadInstructions.domTravelerDeclaration;

export default UploadInstructions;
